import React from 'react'
import { TICKET_FAQS_URL } from '../../Config/config'
import * as Icons from '../../Components/Icons'
import { HeadItem, ScheduleHead, Toggle, Toggle2 } from './schedStyles'
import { logEvent } from '../../Utils'
import { colors } from '../../Components/consts'
import {
  EVENTS_YEAR,
  addToCalendarIds,
  isChampSeriesLive,
} from '../../Config/League/league.config'
import { Desc } from '../../Components/Typography/Text.styles'
import { Switch } from '../../Components/LazyComponents'

type HeaderParams = {
  team?: string
  page: string
  showListView: boolean
  showHeaderItems?: boolean
  onViewToggle?: () => void
}

export const ScheduleHeader: React.FC<React.PropsWithChildren<HeaderParams>> = ({
  team,
  showListView,
  showHeaderItems = true,
  onViewToggle,
  page,
}) => {
  const eventAnalytics = {
    event: 'add_events_click',
    params: {
      calendar: team,
      section: `${page} header`,
    },
  }
  const calendarId = addToCalendarIds['league']

  return (
    <ScheduleHead>
      <div className="left">
        <h1>
         {EVENTS_YEAR} PLL {page}
        </h1>
        {!isChampSeriesLive && (
          <Toggle>
            <Switch
              size="small"
              checked={showListView}
              onChange={onViewToggle}
              inputProps={{ 'aria-label': 'controlled' }}
            />
            <Desc textColor={colors.white}>List View</Desc>
          </Toggle>
        )}
      </div>
      <div
        className="right"
        onClick={() => logEvent(eventAnalytics.event, eventAnalytics.params)}
      >
        <>
          {showHeaderItems && (
            <>
              <HeadItem
                href={TICKET_FAQS_URL}
                aria-label="Ticket FAQs"
                className="headItem"
                onClick={() => {
                  logEvent('ticket_faqs_click', {
                    location: `Schedule_header_item`,
                  })
                }}
              >
                <Icons.Tickets className="icon" fill={colors.white} />
                <p>FAQs</p>
              </HeadItem>
              {calendarId &&<HeadItem
                href={`https://www.addevent.com/calendar/${calendarId}`}
                aria-label="Add to Calendar"
              >
                <Icons.AddToCal width={20} height={25} fill={colors.white} />
                <p>{`Add`}</p>
              </HeadItem>}
            </>
          )}
        </>
        {!isChampSeriesLive && showHeaderItems && (
          <Toggle2>
            <Switch
              size="small"
              checked={showListView}
              onChange={onViewToggle}
              inputProps={{ 'aria-label': 'controlled' }}
            />
            <Desc color={colors.white}>List View</Desc>
          </Toggle2>
        )}
      </div>
    </ScheduleHead>
  )
}
